import React, { useState, useEffect } from 'react'
import parse from 'html-react-parser'
import Plus from '@components/Icons/Plus.jsx'
import Minus from '@components/Icons/Minus.jsx'
import Earth from '@components/Icons/Earth.jsx'
import Cloud from '@components/Icons/Cloud.jsx'
import Heart from '@components/Icons/Heart.jsx'
import Asterisk from '@components/Icons/Asterisk.jsx'
import Location from '@components/Icons/Location.jsx'
import GotsImage from '../../assets/images/gots-label.png'

//

const AccordionItem = ({ itemData, index, type = 'desc', nogots, age }) => {
    const [isOpen, setIsOpen] = useState(false)

    let icon
    let title
    let desc

    if (type === 'desc') {
        if (age) {
            title =
                'Product Details: ' + age.charAt(0).toUpperCase() + age.slice(1)
        } else {
            title = 'Product Details'
        }
        icon = <Asterisk width="w-[21px]" />

        desc = itemData
    } else if (itemData && itemData.title === 'Sustainability') {
        icon = <Earth width="w-[21px]" />
        title = 'Sustainability'
        desc = itemData.description
    } else if (itemData.title === 'Materials') {
        icon = <Cloud width="w-[21px]" />
        title = 'Materials'
        desc = itemData.description
    } else if (itemData.title === 'Care') {
        icon = <Heart width="w-[21px]" />
        title = 'Care'
        desc = itemData.description
    } else if (type === 'location') {
        icon = <Location width="w-[21px]" />
        title = 'Location Information'
        const address2 = itemData.inPersonAddress2 ? `&nbsp;${itemData.inPersonAddress2}` : ''
        desc = `${itemData.inPersonVenue}<br />${itemData.inPersonAddress}${address2}<br />${itemData.inPersonCity}, ${itemData.inPersonState}&nbsp;${itemData.inPersonZip}`
    } else if (type === 'reg') {
        icon = <Asterisk width="w-[21px]" />
        title = 'Registration'
        desc = `<a className="underline text-ocean my-2" href="${itemData.regUrl}" target="_blank" rel="noopener noreferrer">Register Now ↗</a>`
    } else {
        icon = <Asterisk width="w-[21px]" />
        title = itemData.title || ''
        desc = itemData.description || ''
    }

    useEffect(() => {
        if (type === 'desc') {
            setIsOpen(true)
        }
    }, [])

    return (
        <li className="py-3 border-t border-slate accordion-item-nosto">
            <h3
                className="flex items-center cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                <i className="mr-2">{icon}</i>
                {title}{' '}
                <span className="toggle ml-auto">
                    {isOpen ? (
                        <Minus width="w-[21px]" />
                    ) : (
                        <Plus width="w-[21px]" />
                    )}
                </span>
            </h3>
            <div
                className={`accordion-content transition-max-height duration-500 overflow-auto ${
                    isOpen ? 'py-2 block' : 'max-h-0 invisible'
                }`}
            >
                <div className={`font-normal product-desc`}>
                    {type && type === 'desc' && !nogots ? (
                        <div className="gots-image float float-right ml-2 mb-2">
                            <img
                                src={GotsImage.src}
                                alt="GOTS Certified"
                                className="w-24"
                            />
                        </div>
                    ) : null}
                    <div className="product-description">{parse(desc)}</div>
                </div>
            </div>
        </li>
    )
}

export default AccordionItem
